import base from "../baseurl";
import token from "../getTk";

const Delete = async (companyIds) => {
  console.log(companyIds);
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  const Create = await api
    .post("sons/unverified", {
      json: {
        companyIds,
      },
    })
    .json();
  return Create;
};

export default Delete;
